import React, { useRef, useState, useEffect } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import TooltipText from "../../common/tooltipText";

const TeacherBatchCard = ({
  batch,
  index = 0,
  onClick,
  hideActions = true,
}) => {
  const [openMenu, setOpenMenu] = useState(false);
  const menuRef = useRef(null);

  const handleMenuBtn = (e) => {
    e.stopPropagation();
    setOpenMenu((s) => !s);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    setOpenMenu(false);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    setOpenMenu(false);
  };

  useEffect(() => {
    const onDocClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenu(false);
      }
    };
    if (openMenu) document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [openMenu]);

  const codeText = batch?.code || batch?.title || `Batch ${index + 1}`;
  const courseText =
    batch?.courseName ||
    batch?.name ||
    batch?.description ||
    "Full Stack Development";
  const countText =
    batch?.teachers?.length ??
    batch?.studentsCount ??
    batch?.studentCount ??
    34;

  const formatDateTime = (dt) => {
    if (!dt) return "--";
    try {
      const d = new Date(dt);
      if (Number.isNaN(d.getTime())) return String(dt);
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yy = String(d.getFullYear()).slice(-2);
      const hh = String(d.getHours()).padStart(2, "0");
      const min = String(d.getMinutes()).padStart(2, "0");
      return `${dd}/${mm}/${yy}  ${hh}:${min}`;
    } catch (e) {
      return String(dt);
    }
  };

  return (
    <div className="homework-batch-card" key={index} onClick={onClick}>
      <div className="meta-row">
        <h6 className="batch-code" title={codeText}>
          {courseText?.charAt(0).toUpperCase() + courseText?.slice(1)}
        </h6>

        {!hideActions && (
          <div className="meta-row-right">
            <div className="batch-actions" ref={menuRef}>
              <button
                className="action-btn"
                onClick={handleMenuBtn}
                aria-haspopup="menu"
                aria-expanded={openMenu}
                aria-label="Batch actions"
              >
                <MoreVertIcon fontSize="small" />
              </button>
              {openMenu && (
                <div
                  className="batch-actions-menu"
                  role="menu"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    type="button"
                    className="actions-item"
                    onClick={handleEdit}
                    role="menuitem"
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <EditIcon fontSize="small" />
                      Edit
                    </span>
                  </button>
                  <button
                    type="button"
                    className="actions-item danger"
                    onClick={handleDelete}
                    role="menuitem"
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                      Delete
                    </span>
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div>
        <div className="center-content">
          <p>Teacher</p>
          <div className="center-count">
            <PersonOutlineIcon className="footer-icon" fontSize="small" />
            <span>{countText}</span>
          </div>
        </div>

        <div className="footer-row">
          <span className="time-item">
            <TooltipText
              text={`Created: ${formatDateTime(batch?.created_at)}`}
              always
              fullWidth
              placement="bottom"
            />
          </span>
          <span className="time-item">
            <TooltipText
              text={`Updated: ${formatDateTime(batch?.updated_at)}`}
              always
              fullWidth
              placement="bottom"
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default TeacherBatchCard;
